export const parsePrice = price => {
  return isFinite(+price) ? +price : 0;
};
export const formatPrice = (amount, currencyCode) => {
  return Intl.NumberFormat('en-EN', {
    style: 'currency',
    currency: currencyCode
  }).format(amount);
};
export const convertCurrencyCodeToSymbol = currencyCode => {
  return currencyCode.replace('USD', '$').replace('EUR', '€').replace('GBP', '£');
};
export const convertCurrencySymbolToCode = currencySymbol => {
  return currencySymbol.replace('$', 'USD').replace('€', 'EUR').replace('£', 'GBP');
};